import React, { Suspense, useMemo } from 'react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { CalendarViewsProvider } from './view/calendarViewsProvider';
import { Box } from '@mui/system';
import { useMediaQuery } from '@mui/material';

// Dynamically import the WeekNavigation components for desktop and mobile
const KeteroCalendarControllerDesktop = React.lazy(() => import('./keteroCalendarController_desktop')); // Desktop version
const KeteroCalendarControllerMobile = React.lazy(() => import('./keteroCalendarController_mobile'));   // Mobile version

const KeteroCalendarController = () => { 
  const compact = useMediaQuery('(max-width: 899px), (max-height: 600px)');
  const appTheme = useTheme();
  const calendarTheme = useMemo(() => createTheme(appTheme, {
    typography: {
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontWeightBold: 600,
      button: { textTransform: 'none', fontWeight: 500 },
      subtitle1: { fontSize: '0.875rem', fontWeight: 600 },
      body1: { fontSize: '0.875rem' },
      body2: { fontSize: '0.8125rem' },
    },
    ...(appTheme.palette.mode === 'light' ? {
      palette: {
        primary: { main: '#245beb' },
        text: { primary: '#243247', secondary: '#64748b' },
        divider: '#e2e8f0',
        background: { default: '#fafbfd', paper: '#ffffff' },
      },
    } : {}),
  }), [appTheme]);
  return (
    <ThemeProvider theme={calendarTheme}>
    <CalendarViewsProvider defaultView={compact ? 'day' : 'week'} allowWeek={!compact} compact={compact}>
      <Box sx={{
        bgcolor: (theme) => theme.palette.mode === 'light' ? '#fafbfd' : 'background.default',
        p: compact ? 0.5 : { xs: 1.5, sm: 2.5, md: 3 },
        minHeight: 'calc(100dvh - var(--business-header-height, 52px))',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        fontFamily: calendarTheme.typography.fontFamily,
        '& .MuiTypography-root': { fontFamily: 'inherit' },
        color: 'text.primary',
      }}>
      <Suspense fallback={<div>Loading...</div>}>
        {/* Conditionally render the mobile or desktop version based on screen size */}
        {compact ? <KeteroCalendarControllerMobile /> : <KeteroCalendarControllerDesktop />}
      </Suspense>
      </Box>
    </CalendarViewsProvider>
    </ThemeProvider>
  );
};

export default KeteroCalendarController;
